import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class MegaMenuService {
  readonly resetState$ = new BehaviorSubject<boolean>(true);
}
